export default __webpack_public_path__ + "static/media/Billing-Address.b33ee597.jpg";